import SvgIcon from '@mui/material/SvgIcon';

export default function ForwardIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M9.0201 6.23051C9.33854 5.891 9.87239 5.87461 10.2119 6.19305L15.7331 11.3677C15.904 11.5269 16 11.7493 16 11.9835C16 12.2176 15.904 12.4401 15.7354 12.597L10.2142 17.7716C9.87473 18.09 9.34088 18.0736 9.02244 17.7341C8.704 17.3946 8.72039 16.8608 9.0599 16.5423L13.9231 11.9835L9.05756 7.42232C8.71805 7.10388 8.70166 6.57003 9.0201 6.23051Z" />
    </SvgIcon>
  );
}
